import React, { useState, useEffect } from "react";
import Button from "./Button";
import { useNavigate } from "react-router";
import * as Const from "./../_Const";
import { useFormCtx } from "./../FormContext";
import useWindowSize from "../hooks/useWindowSize";
import useOnlineStatus from "../hooks/useOnlineStatus";
const Error = ({
  title = "Chyba aplikace",
  subtitle = "Nastala chyba v aplikaci",
  message = "Zkontrolujte připojení k internetu a akci opakujte",
  message2,
  showButton = true,
}) => {
  const online = useOnlineStatus();
  const [onlineAfterLoad, setOnlineAfterLoad] = useState(online);

  const navigate = useNavigate();
  const { width, height } = useWindowSize();
  const { lastError, navigateHome, isDarkMode, logd } = useFormCtx();
  const showError = lastError && lastError > 0 ? true : false;
  const image = isDarkMode ? "/img/logo_cekarnavmobilu_dark.png" : "/img/logo_cekarnavmobilu.png";
  const showStatus = Const.isDebugMode() || Const.isPreproduction() ? true : false;
  //jaka je hodnota po 1 nactenit
  useEffect(() => {
    let localOnline = online;
    // //v debu si nastav co je treba pro test
    // if (Const.isDebugMode()) {
    //   localOnline = false;
    // }
    logd("online po loadu stranky:" + localOnline);
    setOnlineAfterLoad(localOnline);
  }, []);

  function getMargin() {
    const h = height;

    let margin = "mt-1";
    if (h >= 600 && h < 700) {
      margin = "mt-2";
    } else if (h >= 700 && h < 800) {
      margin = "mt-6";
    } else if (h >= 800) {
      margin = "mt-10";
    }
    return margin;
  }

  function fullReloadHome() {
    //po presmerovani na home je treba udelat ful reload aby stranka fungovala po vypadku internetu
    navigateHome();
    //udela full reaload page, aby se nacetla dat z internetu na home page
    navigate(0);
  }

  //render stranky po tom co puvodne byla onlineAfterLoad = false a nyni je online = true
  if (online && !onlineAfterLoad) {
    //spust full reload
    logd("reload after is back online");
    fullReloadHome();
  }

  return (
    <div className="h-dvh place-content-center text-center mx-6">
      {showStatus && <div className="text-accent-dark dark:text-accent text-sm">{online ? "Online" : "Offline"}</div>}
      <div className="text-accent-dark dark:text-accent font-black text-[42px]">{title}</div>

      <div className={`flex justify-center items-center ${getMargin()}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 259.625 230.778" className="h-52 w-52 sm:h-60 sm:w-60">
          <path
            id="Icon_awesome-exclamation-triangle"
            data-name="Icon awesome-exclamation-triangle"
            d="M256.7,198.33a21.648,21.648,0,0,1-18.74,32.447H21.66A21.648,21.648,0,0,1,2.919,198.33L111.072,10.811a21.648,21.648,0,0,1,37.481,0Zm-126.89-38.769A20.734,20.734,0,1,0,150.546,180.3,20.734,20.734,0,0,0,129.812,159.561ZM110.127,85.033l3.344,61.3a5.409,5.409,0,0,0,5.4,5.114h21.882a5.409,5.409,0,0,0,5.4-5.114l3.344-61.3a5.409,5.409,0,0,0-5.4-5.7H115.528a5.409,5.409,0,0,0-5.4,5.7Z"
            transform="translate(0)"
            fill={isDarkMode ? "#2E9D8F" : "#174842"}
          />
        </svg>
      </div>

      <div className={`text-accent-dark dark:text-accent text-2xl font-bold ${getMargin()}`}>{subtitle}</div>
      {showError && <div className="font-light text-secondary">Chyba {lastError}</div>}

      <div className={`text-accent-dark dark:text-accent text-xl font-light ${getMargin()}`}>{message}</div>

      {message2 && <div className="text-accent-dark dark:text-accent text-xl mt-6 font-light">{message2}</div>}

      <div className={`flex justify-items-center place-content-center ${getMargin()}`}>
        <img src={process.env.REACT_APP_PUBLIC_URL + image} width={250} />
      </div>

      {showButton && (
        <div className="absolute bottom-0 mb-4 left-1/2 transform -translate-x-1/2 ">
          <Button type="error-dark" title={"Opakovat"} showIcon={false} onClick={fullReloadHome} />
        </div>
      )}
    </div>
  );
};

export default Error;
